const FETCH_ALL_TRANSACTIONS_REQUEST = 'FETCH_ALL_TRANSACTIONS_REQUEST';
const FETCH_ALL_TRANSACTIONS_SUCCESS = 'FETCH_ALL_TRANSACTIONS_SUCCESS';
const FETCH_ALL_TRANSACTIONS_FAILURE = 'FETCH_ALL_TRANSACTIONS_FAILURE';

export default {
  FETCH_ALL_TRANSACTIONS_REQUEST,
  FETCH_ALL_TRANSACTIONS_SUCCESS,
  FETCH_ALL_TRANSACTIONS_FAILURE,
};
